import createSvgIcon from '../Utils/CreateSvgIcon';

export const Sunroof = createSvgIcon(
  <path
    d="M13 2V5H11V2L13 2ZM5.63679 4.2216L7.75811 6.34292L6.3439 7.75714L4.22258 5.63582L5.63679 4.2216ZM16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12ZM18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12ZM2 11H5V13H2L2 11ZM22 11H19V13H22V11ZM19.7816 18.3634L17.6602 16.2421L16.246 17.6563L18.3673 19.7776L19.7816 18.3634ZM13 22V19H11V22H13ZM19.7774 5.63582L17.6561 7.75714L16.2419 6.34292L18.3632 4.2216L19.7774 5.63582ZM5.63266 19.7776L7.75398 17.6563L6.33977 16.2421L4.21845 18.3634L5.63266 19.7776Z"
    fillRule="evenodd"
  />,
  'Sunroof',
);
